export default __webpack_public_path__ + "testimonials-quote-dark.113f56ef.svg";